import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Router from './routes';
import ThemeProvider from './theme';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import "./styles/styles.css"
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import errorHandler from './utils/errorHandler';
import apiAuth from './services/authServiceLogin';

// ----------------------------------------------------------------------

export default function App() {
  const userPermision = useSelector((state) => state?.auth?.user);
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [data, setData] = useState();

  useEffect(() => {
    if (userPermision || isLoggedIn) {
      const fetchData = async () => {
        try {
          const response = await apiAuth.getAdminDetails();
          const adminData = response?.data?.data;          
          localStorage.setItem("user",JSON.stringify(adminData))
          setData(adminData);
        } catch (error) {
          errorHandler(error);
        }
      };
      fetchData();
    }
  }, [userPermision ,isLoggedIn]);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover limit={6} />
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          <Router data={data}/>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

